import { MonitoringBriefResponseDto } from '@/app/common/general-types/social-screening.dto';
import { Component, inject, Input, signal } from '@angular/core';
import { Router } from '@angular/router';
import { RecruitGroupPicker } from '@/app/molecules/recruit-group-picker/recruit-group-picker';

@Component({
  selector: 'mon-kanban-card',
  imports: [RecruitGroupPicker],
  templateUrl: './mon-kanban-card.html',
  styleUrl: './mon-kanban-card.css',
})
export class MonKanbanCard {


  readonly showGroupPicker = signal(false);

  selectCreatorGroup(): void {
    this.showGroupPicker.set(true);
  }
  @Input() brief!: MonitoringBriefResponseDto;

  /** Services */
  private router = inject(Router);
  /** Services - END */

  formatDate(date: Date | string | undefined): string {
    if (!date) {
      return 'N/A';
    }

    const dateObj = date instanceof Date ? date : new Date(date);
    if (Number.isNaN(dateObj.getTime())) {
      return 'Invalid date';
    }

    return new Intl.DateTimeFormat('en-GB', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    }).format(dateObj);
  }

}
